import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { getAllBranches } from "../APIs/Api";
import BranchList from "./BranchList/BranchList";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const BranchPopupModel = () => {
  
  const userLocation = useSelector((state) => state.userLocation);
  const lat = localStorage.getItem("lat") ? localStorage.getItem("lat") : userLocation?.location?.lat || "";
  const lng = localStorage.getItem("lng") ? localStorage.getItem("lng") : userLocation?.location?.lng || "";
  const disableScrollOnOpen = () => {
    document.body.style.overflow = "hidden";
  };
  const disableScrollOnClose = () => {
    document.body.style.overflow = "auto";
  };

  const serviceType = localStorage.getItem("type")

  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(true);
  let [branchesArr, setBranchesArr] = useState([]);

  //#region localization code
  const { t, i18n } = useTranslation();
  let [isArabic, setIsArabic] = useState(
    i18n.resolvedLanguage == "ar" ? true : false
  );
  useEffect(() => {
    if (i18n.resolvedLanguage == "en") {
      setIsArabic((isArabic = false));
    } else {
      setIsArabic((isArabic = true));
    }
  }, [i18n.resolvedLanguage]);
  //#endregion

  useEffect(() => {
    getAllBranchesApiCall();
  }, []);
  const getAllBranchesApiCall = () => {
    setIsLoading(true);
    let type = serviceType || 0
    
    getAllBranches(1, 1000, type, lat, lng)
      .then((res) => {
        
        setIsLoading(false);
        if (res.data.data.getAllBranchs.error_code == 0) {
          setBranchesArr((branchesArr = res.data.data.getAllBranchs.result));
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err", err);
      });
  };
  return (
    <>
      <Modal
        onAfterOpen={disableScrollOnOpen}
        onAfterClose={disableScrollOnClose}
        isOpen={isModalOpen}
        shouldCloseOnOverlayClick={false}
        onRequestClose={() => setIsModalOpen(false)}
        // style={customStyles}
        className="Branch_Modal"
        overlayClassName="Branch_Overlay"
      >
        <div className="Pop_Select_Branch_Text_Style">
          {t("select_the_branch")}
        </div>
        {isLoading ? (
          <div
            style={{
              fontSize: "5em",
              textAlign: "center",
            }}
          >
            {t("loading")}
          </div>
        ) : !isLoading && branchesArr.length > 0 && branchesArr != null ? (
          branchesArr.map((item) => (
            <BranchList setIsModalOpen={setIsModalOpen} branchData={item} />
          ))
        ) : (
          <div
            style={{
              fontSize: "5em",
              textAlign: "center",
            }}
          >
            No Branch Found...
          </div>
        )}
      </Modal>
    </>
  );
};

export default BranchPopupModel;
